import React, { useState } from 'react';
import {
  SectionPlaceholderCloudImage,
  OverlayWrapper,
  StyledEcoText,
  SectionContainer,
  StyledColumns,
  StyledLazyLoadWrapper,
} from './EcoSection.styles';
import { weddingInvitationsPageData } from '@data-ts/pages/wedding-invitations';
import { PhotoCredit } from '@components/PhotoCredit';
import { Columns } from '@components/Columns';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';

export const EcoSection: React.FC = () => {
  const { ecoSectionData } = weddingInvitationsPageData;
  const isMobileDevice = useThemeMediaQuery('below_sm');
  const sectionId = 'Wedding_Invitations_Environmentally-Friendly';
  const [isVisible, setIsVisible] = useState(false);

  return (
    <SectionContainer id={sectionId}>
      <StyledLazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
        <div />
      </StyledLazyLoadWrapper>
      <SectionPlaceholderCloudImage
        isResizeDisabled={true}
        src={'save-the-date/eco/bg.jpg'}
        alt={ecoSectionData.altText}
        isMainSrcShown={isVisible}
      />
      <OverlayWrapper>
        <StyledColumns>
          <Columns.Column>
            <StyledEcoText
              alignment="center"
              eyebrow={ecoSectionData.eyebrow}
              eyebrowVariant="sectionEyeBrow20"
              eyebrowColor="humana3"
              eyebrowTagName="h2"
              title={ecoSectionData.title}
              titleVariant="hed56"
              titleColor="mono7"
              titleTagName="h2"
              body={isMobileDevice ? ecoSectionData.contentMobile : ecoSectionData.content}
              bodyColor="mono7"
              bodyVariant="dek20"
            />
          </Columns.Column>
        </StyledColumns>
        <PhotoCredit color="green3" id="photoCreditWeddingInvitations" />
      </OverlayWrapper>
    </SectionContainer>
  );
};
